/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/AssistantAndProvider/Content/Change/Content/Provider/Loading"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 disabled={true}
 alignItems="stretch"
 textAlign="left"
 width="100%"
 marginBottom={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Provider"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}